import { forwardRef, useImperativeHandle, useState } from "react";
import { Input, Text } from "@postenbring/hedwig-react";
import Translated from "../infrastructure/translation/Translated";
import { CertificateCreationRequest } from "../infrastructure/api/api";
import { useTranslate } from "../infrastructure/translation/useTranslate";
import styles from "./NewCertificatePage.module.css";
import { CertificateFormHandle, CertificateFormProps } from "./certificateForm";

export const GenerateCertificate = forwardRef<
  CertificateFormHandle,
  CertificateFormProps
>(({ displayName, fetcher, clearError }, ref) => {
  const translate = useTranslate();
  const [keyStorePass, setKeyStorePass] = useState("");

  useImperativeHandle(ref, () => ({
    submit: () => {
      const body: CertificateCreationRequest = {
        keyStorePass,
        displayName,
      };
      fetcher.submit(body, { method: "post", encType: "application/json" });
    },
  }));

  return (
    <div className={styles.field}>
      <Input
        label={translate("new_certificate.keystore_password")}
        type="password"
        autoComplete="new-password"
        value={keyStorePass}
        onChange={(e) => {
          setKeyStorePass(e.target.value);
          clearError();
        }}
        required
      />
      <Text variant="body-small" className={styles.help}>
        <Translated textKey={"new_certificate.keystore_password_help"} />
      </Text>
    </div>
  );
});

GenerateCertificate.displayName = "GenerateCertificate";
